import { Sale, Tab, PaymentMethod, SalePaymentMethod } from '@/types';

export const createSaleDataForInvoice = (
  saleId: string,
  tab: Tab,
  discount: number | null,
  serviceCharge: number | null,
  serviceChargeRate: number | null,
  tip: number | null,
  paymentMethodsForSale: { methodId: string; amount: number; defaultPaymentMethodId?: number }[],
  organizationId: string
): Sale => {
  return {
    id: saleId,
    items: tab.items,
    discount: discount || 0,
    serviceCharge: serviceCharge || undefined,
    serviceChargeRate: serviceChargeRate || undefined,
    tip: tip ?? undefined,
    paymentMethods: [{
      paymentMethod: { defaultPaymentMethodId: paymentMethodsForSale[0]?.defaultPaymentMethodId } as PaymentMethod
    } as SalePaymentMethod],
    saleDate: new Date(),
    organizationId
  } as Sale;
};

/** Display name for "Sold by" column. Legacy uses soldByName; new sales use FK refs. */
export const getSaleSellerDisplayName = (sale: Sale): string => {
  if (sale.soldByName?.trim()) {
    return sale.soldByName.trim();
  }
  if (sale.soldBySimpleUser?.username?.trim()) {
    return sale.soldBySimpleUser.username.trim();
  }
  if (sale.soldByProfile?.full_name?.trim()) {
    return sale.soldByProfile.full_name.trim();
  }
  return 'Unknown';
}
/** Stable key for grouping/filtering sellers across member + simple user. */
export const getSaleSellerKey = (sale: Sale): string => {
  if (sale.soldBySimpleUserId) {
    return `simple:${sale.soldBySimpleUserId}`;
  }
  if (sale.soldBy) {
    return `member:${sale.soldBy}`;
  }
  if (sale.soldByName?.trim()) {
    return `legacy-name:${sale.soldByName.trim()}`;
  }
  return 'unknown';
}